/**
 * The doors of Acceso that open rarely — «Elegir dónde entrar», «Crea tu PIN» and the invitation's «Crear tu cuenta» —
 * load apart from the Panel's entry. The runtime warms them while the browser is idle at boot (and at once on the
 * invitation's own address), so the door they open into has them long before it hands over to them; until then the
 * door keeps its photograph, its orbs and its brand row and draws an empty column.
 */
import { lazy, Suspense, type ComponentProps } from 'react';

const loadPicker = () => import('./acceso-picker');
const loadRotation = () => import('./credential-rotation');
const loadClaim = () => import('./claim-account');

const LazyPicker = lazy(() => loadPicker().then((module) => ({ default: module.MembershipPicker })));
const LazyRotation = lazy(() => loadRotation().then((module) => ({ default: module.CredentialRotationGate })));
const LazyClaim = lazy(() => loadClaim().then((module) => ({ default: module.ClaimAccountScreen })));

type PickerProps = ComponentProps<typeof import('./acceso-picker').MembershipPicker>;
type RotationProps = ComponentProps<typeof import('./credential-rotation').CredentialRotationGate>;
type ClaimProps = ComponentProps<typeof import('./claim-account').ClaimAccountScreen>;

export function MembershipPicker(props: PickerProps) {
  return <Suspense fallback={null}><LazyPicker {...props} /></Suspense>;
}

export function CredentialRotationGate(props: RotationProps) {
  return <Suspense fallback={null}><LazyRotation {...props} /></Suspense>;
}

export function ClaimAccountScreen(props: ClaimProps) {
  return <Suspense fallback={null}><LazyClaim {...props} /></Suspense>;
}

/** Warms the three doors; a failed load is forgotten, and the door's own load reports it. */
export function preloadAccesoDoors(): void {
  for (const load of [loadPicker, loadRotation, loadClaim]) void load().catch(() => undefined);
}
